import "../common.scss";
import "./Herosection.scss";
import FloxyPaylogo from "../../assets/floxylogoimg.png";
import Herosection1 from "../../assets/Floxyherosectionimg.png";
import Herosection2 from "../../assets/herosection2.png";
import list1 from "../../assets/bottom1.png";
import list2 from "../../assets/bottom2.png";
import list3 from "../../assets/bottom3.png";
import list4 from "../../assets/bottom4.png";
import list5 from "../../assets/bottom5.png";
import list6 from "../../assets/bottom6.png";
import logoimg1 from "../../assets/logoimg1.png";
import logoimg2 from "../../assets/logoimg2.png";
import logoimg3 from "../../assets/logoimg3.png";
import logoimg4 from "../../assets/logoimg4.png";
import logoimg5 from "../../assets/logoimg5.png";
import logoimg6 from "../../assets/logoimg6.png";
import logoimg7 from "../../assets/logoimg7.png";
import forbesimg from "../../assets/forbes.png";
import trustimg from "../../assets/trust.png";
import trust from "../../assets/trsutforbes.png";
import bottom2img from '../../assets/bottom2img.jpg';

const logos = [
  { id: 1, src: logoimg1, alt: "Logo 1" },
  { id: 2, src: logoimg2, alt: "Logo 2" },
  { id: 3, src: logoimg3, alt: "Logo 3" },
  { id: 4, src: logoimg4, alt: "Logo 4" },
  { id: 5, src: logoimg5, alt: "Logo 5" },
  { id: 6, src: logoimg6, alt: "Logo 6" },
  { id: 7, src: logoimg7, alt: "Logo 7" },
];

export default function Herosection() {
  return (
    <div className="herosection spacing">
      <div className="header">
        <img src={FloxyPaylogo} alt="error" />
        <button
          onClick={() => {
            window.open('https://forms.gle/7FmYcR7PrDpUbta76', '_blank');
          }}
       className="btnn" >Get Started</button>
      </div>
      <div className="contentmain">
        <div className="top">
          <div className="left">
            <div className="content">
              <h1> Accept Payments in</h1>
              <h1>
                <span>Crypto</span> <span className="instant"> Instantly</span>
              </h1>
              <p>
                Accept crypto from anywhere in the world with Floxy Pay—your
                all-in-one solution for send, receive, and transfer in digital
                currency.
              </p>
              <button onClick={
                ()=>{
                  const form =  document.getElementById('form');
                  if(form){
                    form.scrollIntoView({behavior:'smooth'})
                  }
                }
              } className="btnn">Try Floxy Pay</button>
            </div>
            <div className="trust desktop">
              <img src={forbesimg} alt="error" className="img1" />
              <img src={trustimg} alt="error" className="img2" />
            </div>
          </div>
          <div className="right">
            <img src={Herosection1} alt="error" />
            <div className="trust mobile">
              <img src={trust} alt="error" />
            </div>
          </div>
        </div>
        <div className="mid">
          <div className="logos desktop">
            <img src={logoimg1} alt="error" />
            <img src={logoimg2} alt="error" />
            <img src={logoimg3} alt="error" />
            <img src={logoimg4} alt="error" />
            <img src={logoimg5} alt="error" />
            <img src={logoimg6} alt="error" />
            <img src={logoimg7} alt="error" />
          </div>
          <div className="mobile">
            <div className="logo-marquee">
              <div className="logo-marquee__container">
                <div className="logo-marquee__content">
                  {logos.map((logo) => (
                    <div key={logo.id} className="logo-marquee__item">
                      <img src={logo.src} alt={logo.alt} />
                    </div>
                  ))}

                  {logos.map((logo) => (
                    <div
                      key={`clone-${logo.id}`}
                      className="logo-marquee__item"
                    >
                      <img src={logo.src} alt={logo.alt} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom1 bottom">
          <div className="left">
            <img src={Herosection2} alt="error" />
          </div>
          <div className="right">
            <div className="content">
              <h2>Seamless Control Over Every Crypto Transaction</h2>
              <p>
                Accept crypto your way—with full control over how you get paid,
                convert, and manage every transaction.
              </p>
              <ul>
                <li>
                  <img src={list1} alt="error" />
                  <span>Seamless multi-currency support for global reach.</span>
                </li>
                <li>
                  <img src={list3} alt="error" />
                  <span>Ultra-low fees that maximize every transaction.</span>
                </li>
                <li>
                  <img src={list4} alt="error" />
                  <span>
                    Instant fiat-to-crypto and crypto-to-fiat conversions.
                  </span>
                </li>
                <li>
                  <img src={list5} alt="error" />
                  <span>
                    Auto-convert coins at the best available market rates.
                  </span>
                </li>
                <li>
                  <img src={list6} alt="error" />
                  <span>24/7 expert support, whenever you need it.</span>
                </li>
              </ul>
              <div className="btn">
                <button onClick={()=>{ window.open("https://t.me/rameepaycrypto", "_blank");}} className="btnn">Get Expert Help</button>
                <button onClick={()=>{window.open('https://forms.gle/7FmYcR7PrDpUbta76', '_blank');}} className="createaccount btnn">Get Started</button>
              </div>
            </div>
          </div>
        </div>
          <div className="bottom2 bottom">
          <div className="right">
            <div className="content">
              <h2>Instant Payouts in Crypto or Fiat</h2>
              <p>
              Experience seamless withdrawals with instant payouts directly in your preferred currency. Whether you choose traditional fiat or modern cryptocurrencies, our system ensures quick, secure, and hassle-free transfers—empowering you with complete flexibility and financial freedom.
              </p>
             <div className="btn" style={{marginTop:"20px"}}>
                <button onClick={()=>{ window.open("https://t.me/rameepaycrypto", "_blank");}} className="btnn">Get Expert Help</button>
                <button onClick={()=>{window.open('https://forms.gle/7FmYcR7PrDpUbta76', '_blank');}} className="createaccount btnn">Get Started</button>
              </div>
            </div>
          </div>
            <div className="left">
            <img src={bottom2img} alt="error" />
          </div>
        </div>
      </div>
    </div>
  );
}
